import React from "react";
import AboutHero from "../container/aboutHero/AboutHero";
import AboutBanner from "../container/aboutBanner/AboutBanner";
import AboutCareer from "../container/aboutCareer/AboutCareer";
import AboutDiscover from "../container/aboutDiscover/AboutDiscover";
import AboutSlider from "../container/aboutSlider/AboutSlider";
import AboutWork from "../container/aboutWork/AboutWork";
import AboutValues from "../container/aboutValues/AboutValues";
import AboutDifferent from "../container/aboutDifferent/AboutDifferent";
import { Helmet } from "react-helmet-async";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Radiksez</title>
        <meta
          name="description"
          content="Learn more about Radiksez and our mission, values, and culture."
        />
        <link rel="canonical" href="https://radiksez.com/about-us" />
      </Helmet>

      <AboutHero />
      <AboutBanner />
      <AboutDiscover />
      <AboutSlider />
      <AboutWork />
      <AboutValues />
      <AboutDifferent />
      <AboutCareer />
    </>
  );
};

export default AboutUs;
